import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
    selector: 'app-admin-change-email',
    templateUrl: './admin-change-email.component.html',
    styleUrls: ['./admin-change-email.component.scss'],
    standalone: false
})
export class AdminChangeEmailComponent implements OnInit {
  token: any;

  constructor(
    private route: ActivatedRoute,
    private utility: UtilityService,
    private api: ApiService,
    private router: Router
  ) { 
    this.route.params
      .subscribe(
        (params: any) => {
          this.token = params['token'];
        }
      );
  }

  ngOnInit(): void {
    this.utility.setSpinner(true)
    this.api.apiRequest("post", "admin/changeEmail", {tokens : this.token})
    .subscribe((res) => {
      this.utility.setSpinner(false)
      if(res.status == 'invalidToken'){
        this.utility.openSnackBar("Verification link is invalid. Please request a new one.", "Ok")

      }else{
        this.utility.openSnackBar("Email verified successfully. Please signin to continue.", "Ok")
      }
      this.router.navigateByUrl('auth/admin-signin');

    }, (err)=> {
      this.utility.setSpinner(false)
      this.utility.openSnackBar("Something went wrong.", "Ok")
      this.router.navigateByUrl('auth/admin-signin');
    })
  }

}
